function Business() {
  return (
    <div class="">
      <nav className="bg-primary py-3">
        <div className="px-2 flex items-center justify-between">
          <div className="flex items-center justify-start relative">
            <img
              src="images/Logo (2)-white.png"
              className="h-10 md:h-12"
              alt="Logo"
            />
          </div>

          <div className="md:w-1/6">
            <div className="dropdown relative" data-large-dropdown>
              <button
                className="dropdown-toggle px-3 py-3 text-gray-500 font-medium text-sm leading-tight uppercase rounded shadow-md transition duration-150 ease-in-out flex items-center justify-center h-12 w-full"
                type="button"
                id="dropdownMenuButton1"
                data-large-dropdown-btn
              >
                <span className="px-3 py-3 bg-[#F1F0FB] text-gray-500 transition duration-150 ease-in-out font-medium rounded-full hover:bg-blue-700 hover:shadow-lg hover:text-white focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg active:text-white pointer-events-none">
                  RW
                </span>

                <svg
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fas"
                  data-icon="caret-down"
                  className="w-2 ml-2 pointer-events-none"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 320 512"
                >
                  <path
                    fill="currentColor"
                    d="M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"
                  ></path>
                </svg>
              </button>

              <div className="dropdown-menu large-dropdown shadow-box rounded-md w-full border-0">
                <div className="py-2">
                  <a
                    className="flex items-center px-4 py-2 justify-start bg-white border-0 w-full hover:bg-gray-100 text-sm text-neutral600"
                    // check href below
                    href="no-where"
                  >
                    <span className="mr-3">
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12.1586 10.87C12.0586 10.86 11.9386 10.86 11.8286 10.87C9.44859 10.79 7.55859 8.84 7.55859 6.44C7.55859 3.99 9.53859 2 11.9986 2C14.4486 2 16.4386 3.99 16.4386 6.44C16.4286 8.84 14.5386 10.79 12.1586 10.87Z"
                          stroke="#6F6E83"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M7.15875 14.56C4.73875 16.18 4.73875 18.82 7.15875 20.43C9.90875 22.27 14.4188 22.27 17.1688 20.43C19.5888 18.81 19.5888 16.17 17.1688 14.56C14.4288 12.73 9.91875 12.73 7.15875 14.56Z"
                          stroke="#6F6E83"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                    My Profile
                  </a>
                  <a
                    className="flex items-center py-2 px-4 text-sm justify-start bg-white border-0 w-full hover:bg-gray-100 text-neutral600"
                    //  check href below
                    href="no-where"
                  >
                    <span className="mr-3">
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z"
                          stroke="#6F6E83"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M16.1654 12.4999C16.0544 12.7513 16.0213 13.0301 16.0704 13.3004C16.1194 13.5707 16.2482 13.8202 16.4404 14.0166L16.4904 14.0666C16.6453 14.2214 16.7683 14.4052 16.8521 14.6075C16.936 14.8098 16.9792 15.0267 16.9792 15.2458C16.9792 15.4648 16.936 15.6817 16.8521 15.884C16.7683 16.0863 16.6453 16.2701 16.4904 16.4249C16.3356 16.5799 16.1518 16.7028 15.9494 16.7867C15.7471 16.8706 15.5302 16.9137 15.3112 16.9137C15.0922 16.9137 14.8753 16.8706 14.673 16.7867C14.4706 16.7028 14.2868 16.5799 14.132 16.4249L14.082 16.3749C13.8856 16.1828 13.6362 16.0539 13.3659 16.0049C13.0955 15.9559 12.8167 15.989 12.5654 16.0999C12.3189 16.2056 12.1087 16.381 11.9606 16.6045C11.8126 16.8281 11.7331 17.0901 11.732 17.3583V17.4999C11.732 17.9419 11.5564 18.3659 11.2439 18.6784C10.9313 18.991 10.5074 19.1666 10.0654 19.1666C9.62334 19.1666 9.19941 18.991 8.88685 18.6784C8.57429 18.3659 8.3987 17.9419 8.3987 17.4999V17.4249C8.39225 17.1491 8.30296 16.8816 8.14246 16.6572C7.98195 16.4328 7.75764 16.2618 7.4987 16.1666C7.24735 16.0557 6.96854 16.0226 6.69821 16.0716C6.42788 16.1206 6.17843 16.2495 5.98203 16.4416L5.93203 16.4916C5.77724 16.6465 5.59343 16.7695 5.3911 16.8533C5.18877 16.9372 4.97189 16.9804 4.75286 16.9804C4.53384 16.9804 4.31696 16.9372 4.11463 16.8533C3.9123 16.7695 3.72849 16.6465 3.5737 16.4916C3.41874 16.3368 3.29581 16.153 3.21193 15.9507C3.12806 15.7483 3.08489 15.5314 3.08489 15.3124C3.08489 15.0934 3.12806 14.8765 3.21193 14.6742C3.29581 14.4719 3.41874 14.288 3.5737 14.1332L3.6237 14.0833C3.81581 13.8869 3.94469 13.6374 3.9937 13.3671C4.04272 13.0967 4.00963 12.8179 3.8987 12.5666C3.79306 12.3201 3.61766 12.1099 3.39409 11.9618C3.17051 11.8138 2.90852 11.7343 2.64036 11.7333H2.4987C2.05667 11.7333 1.63275 11.5577 1.32019 11.2451C1.00763 10.9325 0.832031 10.5086 0.832031 10.0666C0.832031 9.62456 1.00763 9.20063 1.32019 8.88807C1.63275 8.57551 2.05667 8.39992 2.4987 8.39992H2.5737C2.84953 8.39347 3.11703 8.30418 3.34145 8.14368C3.56586 7.98317 3.73679 7.75886 3.83203 7.49992C3.94296 7.24857 3.97605 6.96976 3.92703 6.69943C3.87802 6.4291 3.74914 6.17965 3.55703 5.98325L3.50703 5.93325C3.35207 5.77846 3.22914 5.59465 3.14526 5.39232C3.06139 5.18999 3.01822 4.97311 3.01822 4.75408C3.01822 4.53506 3.06139 4.31818 3.14526 4.11585C3.22914 3.91352 3.35207 3.72971 3.50703 3.57492C3.66182 3.41996 3.84563 3.29703 4.04796 3.21315C4.25029 3.12928 4.46717 3.08611 4.6862 3.08611C4.90522 3.08611 5.1221 3.12928 5.32443 3.21315C5.52676 3.29703 5.71058 3.41996 5.86536 3.57492L5.91536 3.62492C6.11176 3.81703 6.36121 3.94591 6.63154 3.99492C6.90187 4.04394 7.18068 4.01085 7.43203 3.89992H7.4987C7.74517 3.79428 7.95538 3.61888 8.10344 3.39531C8.2515 3.17173 8.33096 2.90974 8.33203 2.64159V2.49992C8.33203 2.05789 8.50763 1.63397 8.82019 1.32141C9.13275 1.00885 9.55667 0.833252 9.9987 0.833252C10.4407 0.833252 10.8646 1.00885 11.1772 1.32141C11.4898 1.63397 11.6654 2.05789 11.6654 2.49992V2.57492C11.6664 2.84307 11.7459 3.10506 11.894 3.32864C12.042 3.55221 12.2522 3.72762 12.4987 3.83325C12.75 3.94418 13.0289 3.97727 13.2992 3.92826C13.5695 3.87924 13.819 3.75037 14.0154 3.55825L14.0654 3.50825C14.2202 3.35329 14.404 3.23036 14.6063 3.14649C14.8086 3.06261 15.0255 3.01944 15.2445 3.01944C15.4636 3.01944 15.6804 3.06261 15.8828 3.14649C16.0851 3.23036 16.2689 3.35329 16.4237 3.50825C16.5787 3.66304 16.7016 3.84685 16.7855 4.04918C16.8693 4.25151 16.9125 4.46839 16.9125 4.68742C16.9125 4.90644 16.8693 5.12332 16.7855 5.32565C16.7016 5.52798 16.5787 5.7118 16.4237 5.86658L16.3737 5.91658C16.1816 6.11298 16.0527 6.36243 16.0037 6.63276C15.9547 6.90309 15.9878 7.1819 16.0987 7.43325V7.49992C16.2043 7.74639 16.3797 7.9566 16.6033 8.10466C16.8269 8.25272 17.0889 8.33218 17.357 8.33325H17.4987C17.9407 8.33325 18.3646 8.50885 18.6772 8.82141C18.9898 9.13397 19.1654 9.55789 19.1654 9.99992C19.1654 10.4419 18.9898 10.8659 18.6772 11.1784C18.3646 11.491 17.9407 11.6666 17.4987 11.6666H17.4237C17.1555 11.6677 16.8936 11.7471 16.67 11.8952C16.4464 12.0432 16.271 12.2534 16.1654 12.4999V12.4999Z"
                          stroke="#6F6E83"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                    Settings
                  </a>
                  <button className="flex items-center py-2 px-4 text-sm justify-start bg-white border-0 w-full hover:bg-gray-100 text-neutral600">
                    <span className="mr-3">
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8.89844 7.55999C9.20844 3.95999 11.0584 2.48999 15.1084 2.48999H15.2384C19.7084 2.48999 21.4984 4.27999 21.4984 8.74999V15.27C21.4984 19.74 19.7084 21.53 15.2384 21.53H15.1084C11.0884 21.53 9.23844 20.08 8.90844 16.54"
                          stroke="#EF4444"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M15.0011 12H3.62109"
                          stroke="#EF4444"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M5.85 8.6499L2.5 11.9999L5.85 15.3499"
                          stroke="#EF4444"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                    Sign Out
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>

      <div className="mx-auto mt-7 max-w-[760px] px-3 pb-3">
        <div className="flex flex-col px-3 py-8 bg-white rounded-lg bx-shadow sm:px-6 md:px-8 lg:px-10">
          <div className="self-center mb-2 text-xl lg:text-4xl font-semibold text-gray-700 text-gray-800">
            Add your business
          </div>
          <span className="justify-center text-md text-center text-gray-500 flex-items-center">
            One more step to bring your business global
          </span>
          <div className="py-6 px-3 mt-4 md:mt-8">
            <form action="#">
              <div className="flex flex-col mb-2">
                <div className="mb-6">
                  <label
                    className="text-gray-700 font-medium mb-3"
                    for="business_name"
                  >
                    What is your business legal name?
                  </label>
                  <input
                    id="business_name"
                    type="text"
                    placeholder="Enter your business legal name"
                    class="block w-full h-[50px] px-4 py-2 mt-2 text-gray-700 bg-white border border-gray-300 rounded focus:outline-none"
                    name="business_name"
                    autocomplete="off"
                  />
                </div>

                <div className="mb-6">
                  <label
                    class="text-gray-700 font-medium mb-3"
                    for="business_type"
                  >
                    What is your business known for?
                  </label>
                  <input
                    id="business_type"
                    type="text"
                    placeholder="Enter what your business is known for"
                    className="block w-full h-[50px] px-4 py-2 mt-2 text-gray-700 bg-white border border-gray-300 rounded dark:border-gray-600 focus:outline-none"
                    name="business_type"
                    autocomplete="off"
                  />
                </div>

                <div className="mb-6">
                  <label class="text-gray-700 font-medium mb-3" for="email">
                    Whats your Business email address?
                  </label>
                  <input
                    id="email"
                    type="email"
                    placeholder="Enter your business address"
                    className="block w-full h-[50px] px-4 py-2 mt-2 text-gray-700 bg-white border border-gray-300 rounded dark:border-gray-600 focus:outline-none"
                    name="email"
                    min="3"
                    autocomplete="off"
                  />
                </div>

                <div className="mb-6">
                  <label
                    className="text-gray-700 font-medium mb-3"
                    for="business_location"
                  >
                    Where is your business situated?
                  </label>
                  <select
                    className="block w-full h-[50px] px-4 py-2 mt-2 text-gray-700 bg-white border border-gray-300 rounded dark:border-gray-600 focus:outline-none"
                    id="business_location"
                    name="business_location"
                  >
                    <option>Enter your business location</option>
                  </select>
                </div>
              </div>

              <div className="flex w-full my-4">
                <a
                  href="index.html"
                  className="h-[50px] py-2 px-4 bg-secondary hover:bg-primary focus:ring-purple-500 focus:ring-offset-purple-200 text-white w-full transition ease-in duration-200 text-center text-base font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 rounded flex items-center justify-center"
                >
                  I'm good to go
                </a>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* <script src="js/main.js"></script> */}
    </div>
  );
}

export default Business;
